(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[456],{

/***/ 50343:
/***/ (function(module) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 13324:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(17297),
    toKey = __webpack_require__(33812);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ 1054:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(50857),
    arrayMap = __webpack_require__(50343),
    isArray = __webpack_require__(86152),
    isSymbol = __webpack_require__(4795);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 17297:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(86152),
    isKey = __webpack_require__(21401),
    stringToPath = __webpack_require__(54452),
    toString = __webpack_require__(66188);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ 21401:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(86152),
    isSymbol = __webpack_require__(4795);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ 77777:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoize = __webpack_require__(30733);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ 54452:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(77777);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ 33812:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(4795);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ 72579:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(13324);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ 30733:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(96738);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ 66188:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(1054);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 74568:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collections/[...handle]",
      function () {
        return __webpack_require__(59245);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 59245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _handle_; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/dist/client/router.js
var client_router = __webpack_require__(93642);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
// EXTERNAL MODULE: ../../node_modules/react-infinite-scroll-component/dist/index.es.js
var index_es = __webpack_require__(93808);
// EXTERNAL MODULE: ../../node_modules/react-icons/io5/index.esm.js
var index_esm = __webpack_require__(91914);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/core/networkStatus.js
var core_networkStatus = __webpack_require__(64368);
// EXTERNAL MODULE: ../../node_modules/react-icons/md/index.esm.js
var md_index_esm = __webpack_require__(65186);
// EXTERNAL MODULE: ../../node_modules/lodash/get.js
var get = __webpack_require__(72579);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ../../node_modules/lodash/lodash.js
var lodash = __webpack_require__(76635);
// EXTERNAL MODULE: ./types/product.ts
var product = __webpack_require__(35312);
// EXTERNAL MODULE: ./src/components/Product.tsx + 1 modules
var Product = __webpack_require__(15318);
// EXTERNAL MODULE: ./node_modules/@mui/material/Drawer/Drawer.js + 2 modules
var Drawer = __webpack_require__(77533);
// EXTERNAL MODULE: ./node_modules/@mui/material/Collapse/Collapse.js + 1 modules
var Collapse = __webpack_require__(57922);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ./src/utils/product.ts
var utils_product = __webpack_require__(95249);
// EXTERNAL MODULE: ./src/utils/money.ts
var money = __webpack_require__(13043);
// EXTERNAL MODULE: ./src/utils/constants/filters.ts + 2 modules
var constants_filters = __webpack_require__(7037);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/components/Filter/FilterItem.tsx



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function formatValue(value, type) {
    var v = value;
    if (type === product/* ProductFilterKeys.price */.Tl.price) {
        v = v.replace('-', '/');
    }
    if (type === product/* ProductFilterKeys.size */.Tl.size) {
        return v.toUpperCase();
    }
    return v.replace('/', '-');
}
var FilterItem = function(props) {
    var active = props.active, onSelect = props.onSelect, value = props.value, type = props.type, onActive = props.onActive;
    (0,react.useEffect)(function() {
        onActive === null || onActive === void 0 ? void 0 : onActive(active, value);
    }, [
        active,
        value,
        type
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "text-tiny font-medium my-2 first:mt-0 cursor-pointer flex items-center",
        onClick: function() {
            return onSelect(type, _objectSpread({
            }, value, {
                type: type
            }));
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "inline-block w-4 h-4 mr-2 ".concat(active ? 'bg-black' : '')
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "".concat(active ? 'font-semibold' : ''),
                children: formatValue(value.label, type)
            })
        ]
    }, value.id));
};
/* harmony default export */ var Filter_FilterItem = (FilterItem);

;// CONCATENATED MODULE: ./src/components/Filter/ProductTypeItem.tsx







function ProductTypeItem_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ProductTypeItem_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ProductTypeItem_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var ProductTypeList = function(props) {
    var ref2;
    var onSelect = props.onSelect, value = props.value, className = props.className, checkSelected = props.checkSelected, onParentSelect = props.onParentSelect;
    var ref1 = (0,react.useState)(false), open = ref1[0], setOpen = ref1[1];
    /** Selected children set */ var inSelectedChildren = (0,react.useMemo)(function() {
        var ref;
        return ((ref = value.children) === null || ref === void 0 ? void 0 : ref.filter(function(i) {
            return !checkSelected(product/* ProductFilterKeys.type */.Tl.type, i.label);
        })) || [];
    }, [
        value
    ]);
    var isActive = (0,react.useMemo)(function() {
        var ref;
        return ((ref = value.children) === null || ref === void 0 ? void 0 : ref.some(function(i) {
            return checkSelected(product/* ProductFilterKeys.type */.Tl.type, i.label);
        })) || checkSelected(product/* ProductFilterKeys.type */.Tl.type, value.label);
    }, [
        value
    ]);
    var handleParentSelect = function() {
        if (!value.children) {
            var params = [
                {
                    productType: value.label
                }, 
            ];
            onParentSelect === null || onParentSelect === void 0 ? void 0 : onParentSelect(product/* ProductFilterKeys.type */.Tl.type, [
                {
                    count: 0,
                    input: JSON.stringify(params),
                    label: value.label,
                    id: value.id,
                    type: product/* ProductFilterKeys.type */.Tl.type
                }, 
            ], !!checkSelected(product/* ProductFilterKeys.type */.Tl.type, value.label));
            return;
        }
        // If has unselected children
        // do select all
        if (!inSelectedChildren.length) {
            onParentSelect === null || onParentSelect === void 0 ? void 0 : onParentSelect(product/* ProductFilterKeys.type */.Tl.type, value.children.map(function(i) {
                return ProductTypeItem_objectSpread({
                }, i, {
                    type: product/* ProductFilterKeys.type */.Tl.type
                });
            }), true);
        } else {
            onParentSelect === null || onParentSelect === void 0 ? void 0 : onParentSelect(product/* ProductFilterKeys.type */.Tl.type, inSelectedChildren.map(function(i) {
                return ProductTypeItem_objectSpread({
                }, i, {
                    type: product/* ProductFilterKeys.type */.Tl.type
                });
            }), false);
        }
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()([
                    'text-xs font-medium flex justify-between items-center cursor-pointer',
                    {
                        'py-3': !value.children
                    }, 
                ]),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: classnames_default()([
                            'flex-1',
                            {
                                'font-bold': isActive
                            }
                        ]),
                        onClick: handleParentSelect,
                        children: value.label
                    }),
                    value.children && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-xs p-3 flex-shrink-0",
                        onClick: function() {
                            return setOpen(!open);
                        },
                        children: open ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoChevronUpSharp */.fY0, {
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoChevronDownSharp */.V7A, {
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                in: open,
                children: (ref2 = value.children) === null || ref2 === void 0 ? void 0 : ref2.map(function(i) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Filter_FilterItem, {
                        value: i,
                        onSelect: onSelect,
                        active: Boolean(checkSelected(product/* ProductFilterKeys.price */.Tl.price, i.label)),
                        type: product/* ProductFilterKeys.type */.Tl.type
                    }, i.id);
                })
            })
        ]
    }));
};
/* harmony default export */ var ProductTypeItem = (ProductTypeList);

;// CONCATENATED MODULE: ./src/components/Filter/Filter.tsx

/* eslint-disable react/no-unused-prop-types */ 









function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++){
            arr2[i] = arr[i];
        }
        return arr2;
    }
}
function Filter_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function Filter_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Filter_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
var FILTER_TYPE = [
    'product_type',
    'color',
    'size',
    'price'
];
var FilterPanel = function(props) {
    var ref6;
    var filters = props.filters;
    var _open = props.open, open = _open === void 0 ? false : _open, onOpenChange = props.onOpenChange, onSelect = props.onSelect, defaultSelect = props.defaultSelect, onChange = props.onChange;
    var ref1 = (0,react.useState)(open), visible = ref1[0], setVisible = ref1[1];
    var ref2 = (0,react.useState)([]), selected = ref2[0], select = ref2[1];
    var ref3 = (0,react.useState)(FILTER_TYPE.reduce(function(acc, i) {
        if ([
            'product_type',
            'color'
        ].includes(i)) {
            acc[i] = true;
        } else {
            acc[i] = false;
        }
        return acc;
    }, {
    })), openMap = ref3[0], setOpenMap = ref3[1];
    var formatPriceTag = function(item) {
        if (!item.params) return '';
        var _price = item.params.price, min = _price.min, max = _price.max;
        if (typeof max === 'number' && typeof min === 'number') {
            return "".concat((0,money/* default */.Z)(min).formatPrice(2), "-").concat((0,money/* default */.Z)(max).formatPrice(2));
        }
        return "Over ".concat((0,money/* default */.Z)(min || max || 0).formatPrice(2));
    };
    // Format filter item to selected tag
    var formatTag = function(type, item) {
        if (type === 'price') {
            return formatPriceTag(item);
        }
        return item.label || '';
    };
    var checkSelected = function(type, label) {
        return selected.find(function(i) {
            return i.label.toLowerCase() === label.toLowerCase();
        });
    };
    var checkPriceSelected = function(type) {
        if (type === product/* ProductFilterKeys.price */.Tl.price) return selected.find(function(i) {
            return i.type === product/* ProductFilterKeys.price */.Tl.price;
        });
        return undefined;
    };
    var handleSelect = function(items, param) {
        var isRemove = param === void 0 ? false : param;
        var data = isRemove ? items : _toConsumableArray(selected).concat(_toConsumableArray(items));
        setVisible(false);
        select(data);
        onSelect === null || onSelect === void 0 ? void 0 : onSelect(data);
    };
    var handleRemove = function(value) {
        var valMap = value.reduce(function(acc, i) {
            acc[i.label.toLowerCase()] = i;
            return acc;
        }, {
        });
        var temp = _toConsumableArray(selected).filter(function(i) {
            return !valMap[i.label.toLowerCase()];
        });
        return temp;
    };
    /**
   * Select multiple product type
   */ var selectMultipleItem = function(type, values, param) {
        var isRemove = param === void 0 ? false : param;
        var s = values;
        if (isRemove) {
            s = handleRemove(values);
        }
        handleSelect(s, isRemove);
    };
    var selectItem = function(type, value) {
        var isSelected = checkSelected(type, value.label);
        var isPriceSelect = checkPriceSelected(type);
        var s = [
            value
        ];
        if (isSelected) {
            s = handleRemove([
                isSelected
            ]);
            handleSelect(s, true);
            return;
        }
        if (isPriceSelect) {
            s = handleRemove([
                isPriceSelect
            ]);
            handleSelect(_toConsumableArray(s).concat([
                value
            ]), true);
            return;
        }
        handleSelect([
            value
        ]);
    };
    var getTitle = function(type) {
        if (type === 'productType') return 'category';
        if (type === 'price') return 'price range';
        return type;
    };
    /**
   * Product type filter set
   */ var productFilterSet = (0,react.useMemo)(function() {
        var map = {
        };
        filters === null || filters === void 0 ? void 0 : filters.product_type.values.forEach(function(p) {
            constants_filters/* PRODUCT_SET.forEach */.$Y.forEach(function(i) {
                if (!map[i.name] && i.name.toLowerCase() === p.label.toLowerCase()) {
                    map[i.name] = {
                        label: i.name,
                        type: product/* ProductFilterKeys.type */.Tl.type
                    };
                }
                if (i.childrenStr && i.childrenStr.toLocaleLowerCase().split('+').includes(p.label.toLowerCase())) {
                    if (!map[i.name]) {
                        map[i.name] = {
                            label: i.name,
                            type: product/* ProductFilterKeys.type */.Tl.type
                        };
                    }
                    var item = map[i.name];
                    if (!item.children) {
                        item.children = [];
                    }
                    item.children.push(p);
                }
            });
        });
        return Object.keys(map).map(function(i) {
            return map[i];
        });
    }, [
        filters
    ]);
    var getCollapseValue = function(type) {
        var ref7;
        if (type === 'price') {
            var max = 40;
            try {
                var ref4;
                max = (ref4 = JSON.parse((filters === null || filters === void 0 ? void 0 : filters.price.values[0].input) || {
                })) === null || ref4 === void 0 ? void 0 : ref4.price.max;
            } catch (e) {
                console.log(e);
            }
            return constants_filters/* PRICE_FILTER_SET.filter */.lh.filter(function(i) {
                var ref, ref5;
                return (((ref = i.params) === null || ref === void 0 ? void 0 : (ref5 = ref.price) === null || ref5 === void 0 ? void 0 : ref5.min) || 0) < max;
            });
        }
        if (type === 'color') {
            return constants_filters/* COLOR_FILTERS_SET.filter */.QR.filter(function(i) {
                return filters === null || filters === void 0 ? void 0 : filters.color.values.some(function(v) {
                    return i.input.toLowerCase().indexOf(v.label.toLowerCase()) >= 0;
                });
            });
        }
        if (type === 'product_type') {
            return productFilterSet;
        }
        if (type === product/* ProductFilterKeys.size */.Tl.size) {
            return constants_filters/* SIZE_FILTER_SET.filter */.sc.filter(function(i) {
                return filters === null || filters === void 0 ? void 0 : filters.size.values.some(function(v) {
                    return v.label.indexOf(i.label) >= 0;
                });
            });
        }
        return filters === null || filters === void 0 ? void 0 : (ref7 = filters[type]) === null || ref7 === void 0 ? void 0 : ref7.values;
    };
    (0,react.useEffect)(function() {
        onChange === null || onChange === void 0 ? void 0 : onChange(selected);
    }, [
        selected
    ]);
    (0,react.useEffect)(function() {
        if (defaultSelect) {
            select(defaultSelect);
        }
    }, [
        (ref6 = router["default"].router) === null || ref6 === void 0 ? void 0 : ref6.asPath
    ]);
    (0,react.useEffect)(function() {
        if (open !== visible) {
            setVisible(open);
        }
    }, [
        open
    ]);
    (0,react.useEffect)(function() {
        onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(visible);
    }, [
        visible
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer/* default */.ZP, {
        className: "select-none",
        open: visible,
        onClose: function() {
            return setVisible(false);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "w-76 px-3",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "border-b border-gray-200 py-4 flex justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "font-semibold",
                            children: "FILTER"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cursor-pointer",
                            onClick: function() {
                                return setVisible(false);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoCloseOutline */.IOM, {
                                size: 24
                            })
                        })
                    ]
                }),
                selected.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mb-8",
                    children: selected.map(function(filter) {
                        // Object.keys(filter).map((key) => {
                        // const item = (filter as any)[key]
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                            className: "py-3 pl-4 bg-black text-white flex items-center justify-between font-semibold tracking-wider text-tiny mb-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: formatTag(filter.type, filter).toUpperCase()
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "inline-block px-3 text-lg cursor-pointer",
                                    onClick: function() {
                                        return handleSelect(handleRemove([
                                            filter
                                        ]), true);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoCloseOutline */.IOM, {
                                    })
                                })
                            ]
                        }, filter.label);
                    })
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "py-4",
                    children: FILTER_TYPE.map(function(type) {
                        var ref;
                        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mb-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "text-tiny py-4 font-medium flex justify-between items-center cursor-pointer",
                                    onClick: function() {
                                        return setOpenMap(Filter_objectSpread({
                                        }, openMap, Filter_defineProperty({
                                        }, type, !openMap[type])));
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "font-bold",
                                            children: getTitle(type === 'product_type' ? 'category' : type).toUpperCase()
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-sm",
                                            children: openMap[type] ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoChevronUpSharp */.fY0, {
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoChevronDownSharp */.V7A, {
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                                    in: openMap[type],
                                    children: (ref = getCollapseValue(type)) === null || ref === void 0 ? void 0 : ref.map(function(value, idx) {
                                        /** Render color tags */ if (type === 'color') return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "text-xs inline-flex items-center border p-1 mr-3 mb-3 cursor-pointer",
                                            onClick: function() {
                                                return selectItem(type, Filter_objectSpread({
                                                }, value, {
                                                    type: type
                                                }));
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "w-3.5 h-3.5 inline-block mr-1",
                                                    style: (0,utils_product/* getColorBackground */.Pj)(value.label).style
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: value.label
                                                })
                                            ]
                                        }, idx));
                                        if (type === 'product_type') {
                                            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTypeItem, {
                                                className: "pl-3",
                                                checkSelected: checkSelected,
                                                value: value,
                                                onSelect: selectItem,
                                                onParentSelect: selectMultipleItem
                                            }, idx));
                                        }
                                        /** Ohter tags */ // TODO
                                        var active = checkSelected(type, value.label);
                                        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Filter_FilterItem, {
                                            value: value,
                                            type: type,
                                            active: Boolean(active),
                                            onSelect: selectItem
                                        }, idx));
                                    })
                                })
                            ]
                        }, type));
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ var Filter = (FilterPanel);

;// CONCATENATED MODULE: ./src/components/Filter/index.tsx


/* harmony default export */ var components_Filter = (Filter);

// EXTERNAL MODULE: ./src/components/Container.tsx
var Container = __webpack_require__(98159);
// EXTERNAL MODULE: ./src/components/Loading.tsx
var Loading = __webpack_require__(45760);
// EXTERNAL MODULE: ./src/components/skeleton.tsx
var skeleton = __webpack_require__(89096);
// EXTERNAL MODULE: ./src/components/BackTop.tsx
var BackTop = __webpack_require__(16678);
// EXTERNAL MODULE: ./src/hooks/useCollections.ts
var useCollections = __webpack_require__(31320);
// EXTERNAL MODULE: ./src/utils/constants/index.ts
var constants = __webpack_require__(52372);
// EXTERNAL MODULE: ./src/utils/query-parser.ts
var query_parser = __webpack_require__(21783);
// EXTERNAL MODULE: ./src/utils/helpers.ts
var helpers = __webpack_require__(37336);
;// CONCATENATED MODULE: ./src/pages/collections/[...handle].tsx

/* eslint-disable react/prop-types */ 




















function _handle_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _handle_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _handle_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var collectionPageSensorMod = function() {
    return __webpack_require__.e(/* import() */ 259).then(__webpack_require__.bind(__webpack_require__, 31259));
};
var COLLECTION_PATH = '/collections/[...handle]';
var collectionPageSensor;
var debounceReport = (0,lodash.debounce)(function() {
    return collectionPageSensorMod().then(function(mod) {
        collectionPageSensor = new mod.CollectionPageSensor();
        collectionPageSensor === null || collectionPageSensor === void 0 ? void 0 : collectionPageSensor.Action();
    });
}, 300);
var CollectionPage = function(props) {
    var ref, ref1;
    var shop = props.shop, collection = props.collection;
    var ref2 = collection || {
    }, title = ref2.title, description = ref2.description;
    var fbImage = get_default()(props, 'products.edges[0].node.images.edges[0].node.transformedSrc');
    var router = (0,client_router.useRouter)();
    var ref3 = (0,react.useState)(false), filterVisible = ref3[0], setFilterVisible = ref3[1];
    var ref4 = (0,react.useState)(false), onStatus = ref4[0], setOnStatus = ref4[1];
    var ref5 = (0,react.useState)([]), filterSelected = ref5[0], setFilters = ref5[1];
    var ref6 = (0,useCollections/* useGetCollectionsByHandler */.i)(collection), _query = ref6.query, loading = _query.loading, networkStatus = _query.networkStatus, sortItem = ref6.sortItem, filtersMap = ref6.filtersMap, variables = ref6.variables, fetchMore = ref6.fetchMore, _data = ref6.data, products = _data.products, data = _data.collection, collectionCount = ref6.collectionCount, dispatchInitialQuery = ref6.dispatchInitialQuery;
    /**
   * Sort select action
   */ var handleSortSelect = function(e) {
        router.push({
            pathname: COLLECTION_PATH,
            query: _handle_objectSpread({
            }, router.query, {
                sort_by: e.target.value
            })
        }, undefined, {
            shallow: true
        });
        setOnStatus(false);
        if (e.target.value === 'manual') {
            dispatchInitialQuery(true);
        }
        collectionPageSensor === null || collectionPageSensor === void 0 ? void 0 : collectionPageSensor.SortMethodClick(e.target.value);
    };
    /**
   * Filter action
   */ var handleFilterSelect = function(value) {
        var querys = (0,query_parser/* combineFilters */.v8)(value);
        var temp = _handle_objectSpread({
        }, router.query);
        Object.keys(temp).forEach(function(key) {
            if (key !== 'handle' && key !== 'sort_by' && !querys[key]) {
                delete temp[key];
            }
        });
        router.push({
            pathname: COLLECTION_PATH,
            query: _handle_objectSpread({
            }, temp, querys)
        }, undefined, {
            shallow: true
        });
        if (!Object.keys(querys).length && (!router.query.sort_by || router.query.sort_by === 'manual')) {
            dispatchInitialQuery(true);
        }
    };
    (0,helpers/* useIsomorphicLayoutEffect */.LI)(function() {
        if ( true && data && !router.isFallback) {
            debounceReport();
        }
    }, [
        data
    ]);
    var productCountVisible = (0,react.useMemo)(function() {
        return !router.isFallback && !loading && (products === null || products === void 0 ? void 0 : products.edges.length);
    }, [
        loading,
        router,
        products
    ]);
    var Seo = function() {
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(head["default"], {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                    children: [
                        title || (data === null || data === void 0 ? void 0 : data.title),
                        " - BloomChic"
                    ]
                }),
                (description || (shop === null || shop === void 0 ? void 0 : shop.description) || (data === null || data === void 0 ? void 0 : data.description)) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "description",
                    content: description || (shop === null || shop === void 0 ? void 0 : shop.description) || (data === null || data === void 0 ? void 0 : data.description)
                }),
                fbImage && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:image",
                            content: fbImage
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:image:secure_url",
                            content: fbImage
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:image:width",
                            content: "436"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:image:height",
                            content: "160"
                        })
                    ]
                })
            ]
        }));
    };
    var ref7, ref8, ref9;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !router.isFallback && /*#__PURE__*/ (0,jsx_runtime.jsx)(Seo, {
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                id: "collection",
                "data-id": data === null || data === void 0 ? void 0 : data.id,
                "data-id2": collectionPageSensor === null || collectionPageSensor === void 0 ? void 0 : collectionPageSensor.getCollectionID2((ref7 = data === null || data === void 0 ? void 0 : data.id) !== null && ref7 !== void 0 ? ref7 : ''),
                "data-name": data === null || data === void 0 ? void 0 : data.title,
                className: "collection md:pb-28",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "py-3 flex items-center text-sm sm:text-base -mx-2".concat(loading && ' opacity-40', "\n          ").concat(!products || loading || [
                            core_networkStatus/* NetworkStatus.refetch */.I.refetch,
                            core_networkStatus/* NetworkStatus.setVariables */.I.setVariables
                        ].includes(networkStatus) ? ' pointer-events-none' : ''),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex-1 px-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "py-3 px-5 cursor-pointer flex sm:inline-flex items-center ".concat(filterSelected.length > 0 ? 'bg-black text-white' : ''),
                                    onClick: function() {
                                        return setFilterVisible(true);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoOptionsOutline */.fuK, {
                                            className: "mr-2",
                                            size: 18
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "".concat(filterSelected.length > 0 ? 'text-white' : 'text-black'),
                                                    children: "Filter\xa0"
                                                }),
                                                filterSelected.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    children: [
                                                        "(",
                                                        filterSelected.length,
                                                        ")"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex-1 text-center text-sm hidden sm:block relative",
                                children: productCountVisible ? "".concat(collectionCount, " product").concat(collectionCount > 1 ? 's' : '') : // <Spin>&nbsp;</Spin>
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {
                                    size: 24
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex-1 text-right px-2 relative",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "absolute right-1.5 top-1/2 transform -translate-y-1/2 z-10 transition-transform ".concat(onStatus ? 'rotate-180' : ''),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdOutlineKeyboardArrowDown */.x3N, {
                                            size: 20
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                        value: sortItem === null || sortItem === void 0 ? void 0 : sortItem.searchValue,
                                        className: "py-3 px-5 text-black font-medium",
                                        name: "sortlist",
                                        onChange: handleSortSelect,
                                        onClick: function() {
                                            return setOnStatus(true);
                                        },
                                        onMouseLeave: function() {
                                            return setOnStatus(false);
                                        },
                                        children: constants/* CollectionSortList.map */.W6.map(function(i) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("option", {
                                                value: i.searchValue,
                                                children: i.label
                                            }, i.label);
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-1 text-center text-xs sm:hidden mb-4 relative",
                        children: productCountVisible ? "".concat(collectionCount, " product").concat(collectionCount > 1 ? 's' : '') : // <Spin>&nbsp;</Spin>
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {
                            size: 24
                        })
                    }),
                    filtersMap && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Filter, {
                        open: filterVisible,
                        filters: filtersMap,
                        defaultSelect: (0,query_parser/* parseQueryToFilter */.wS)(router.query, (ref = filtersMap.size) === null || ref === void 0 ? void 0 : ref.values.map(function(i) {
                            return _handle_objectSpread({
                            }, i, {
                                type: product/* ProductFilterKeys.size */.Tl.size
                            });
                        }), (ref1 = filtersMap.product_type) === null || ref1 === void 0 ? void 0 : ref1.values.map(function(i) {
                            return _handle_objectSpread({
                            }, i, {
                                type: product/* ProductFilterKeys.type */.Tl.type
                            });
                        })),
                        onOpenChange: function(open) {
                            return setFilterVisible(open);
                        },
                        onSelect: handleFilterSelect,
                        onChange: function(filters) {
                            return setFilters(filters);
                        }
                    }),
                    !products || !(products === null || products === void 0 ? void 0 : products.edges.length) && loading || [
                        core_networkStatus/* NetworkStatus.refetch */.I.refetch,
                        core_networkStatus/* NetworkStatus.setVariables */.I.setVariables
                    ].includes(networkStatus) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* CollectionSkeleton */.Xn, {
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* default */.Z, {
                        className: "grid grid-cols-2 gap-x-3 md:gap-x-5 md:grid-cols-4 pb-6",
                        next: function() {
                            fetchMore();
                            collectionPageSensor === null || collectionPageSensor === void 0 ? void 0 : collectionPageSensor.CollectionTurnPage(1);
                        },
                        hasMore: Boolean(products === null || products === void 0 ? void 0 : products.pageInfo.hasNextPage),
                        loader: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {
                            className: "w-full flex-1 col-span-2 flex-shrink-0 mt-3 pb-5 md:col-span-4 md:mt-10",
                            size: 35
                        }),
                        dataLength: (products === null || products === void 0 ? void 0 : products.edges.length) || variables.first,
                        children: [
                            products === null || products === void 0 ? void 0 : products.edges.map(function(i, index) {
                                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Product/* default */.Z, {
                                    className: "mb-6",
                                    collectionId: (ref8 = data === null || data === void 0 ? void 0 : data.id) !== null && ref8 !== void 0 ? ref8 : '',
                                    collectionTitle: (ref9 = data === null || data === void 0 ? void 0 : data.title) !== null && ref9 !== void 0 ? ref9 : '',
                                    data: i.node,
                                    productIndex: index + 1
                                }, i.node.id));
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackTop/* default */.Z, {
                            })
                        ]
                    }),
                    !loading && data && !(products === null || products === void 0 ? void 0 : products.pageInfo.hasNextPage) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative text-center text-sm text-gray-400",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "absolute w-full border-b left-0 top-1/2"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "inline-block px-6 bg-white z-10 relative",
                                        children: "No more products"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                href: "/",
                                passHref: true,
                                prefetch: false,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "underline text-center block py-8 text-xs sm:text-base",
                                    style: {
                                        color: '#2f92eb'
                                    },
                                    children: "Back to homepage"
                                })
                            })
                        ]
                    })
                ]
            }, data === null || data === void 0 ? void 0 : data.id)
        ]
    }));
};
var __N_SSG = true;
/* harmony default export */ var _handle_ = (CollectionPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [424,182,644,982,774,888,179], function() { return __webpack_exec__(74568); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);